import { render, staticRenderFns } from "./mortgage-update-details.vue?vue&type=template&id=6b974855"
import script from "./mortgage-update-details.vue?vue&type=script&lang=ts"
export * from "./mortgage-update-details.vue?vue&type=script&lang=ts"
import style0 from "./mortgage-update-details.vue?vue&type=style&index=0&id=6b974855&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports